/**
 * @enum Auth0ThemeType
 */
export enum Auth0ThemeType {
  IMAGE = 'image',
  VIDEO = 'video',
  NOT_SET = 'undefined',
}

/**
 * @enum Auth0Screen
 */
export enum Auth0Screen {
  LOGIN = 'login',
  SIGNUP = 'signup',
}
